"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Permission = void 0;
class Permission {
    static formatDashboardPermission(permission) {
        return {
            userReference: permission.user_reference,
            scope: permission.scope,
            token: permission.token,
            dashboardId: permission.dashboard_id,
        };
    }
    static formatGlobalLibraryPermission(permission) {
        return {
            userReference: permission.user_reference,
            scope: permission.scope,
            token: permission.token,
            globalLibraryId: permission.global_library_id,
        };
    }
    static validateJwtExpiry(token, freshnessBufferInSeconds = 10) {
        try {
            // Split the token into its parts
            const [_header, payload, _signature] = token.split('.');
            // Decode the payload (Base64 decoding)
            const decodedPayload = Buffer.from(payload, 'base64').toString('utf-8');
            const payloadObj = JSON.parse(decodedPayload);
            // Get the expiration time from the payload
            const expirationTime = payloadObj.exp;
            // Get the current timestamp
            const currentTimestamp = Math.floor(Date.now() / 1000);
            // Check if the token has expired
            const hasExpired = expirationTime < currentTimestamp + freshnessBufferInSeconds;
            return !hasExpired;
        }
        catch (error) {
            // Token decoding or validation failed
            return false;
        }
    }
}
exports.Permission = Permission;
